import { React, useEffect } from "react";
import HeroHeader from "./HeroHeader";
import ContactCTA from "./ContactCTA";
import { Helmet } from "react-helmet";
import FibrinMockup from "../img/fibrin_mockup.png";
import FibrinSpread from "../img/fibrin_spread.jpg";
import BrainWIP from "../img/brain_WIP.gif";
import BrainMockup from "../img/Brain.jpg";
import CABG from "../img/CABG_final.png";
import CABG_WIP1 from "../img/CABG_WIP1.jpg";
import CABG_WIP2 from "../img/CABG_WIP2.jpg";

function MedIllus() {
  // useEffect(() => {
  //   document.title = "ETCHNG | Print medical illustrations";
  // }, []);

  return (
    <>

      <Helmet>
        <title>ETCHNG | Print medical illustrations</title>
        <meta name="description" content="Print medical illustrations" />
        <meta name="keywords" content=" ETCHNG, medical illustrator, print, illustrations, medical, anatomy, surgical, CABG" /> </Helmet>
      <HeroHeader
        hero_img={FibrinMockup}
        type="Illustration —"
        name="Print medical illustrations"
      />

      <div className="wrapper">
        <div className="wrapper__inner">
          <div className="work">
            <div className="work__info twoColumn">
              <div className="work__info__basic">
                {/* <div className="work__info__basic__item">
                  {" "}
                  <h5>Date</h5>
                  <p>Nov 2020 </p>{" "}
                </div> */}
                <div className="work__info__basic__item">
                  {" "}
                  <h5>Role</h5>
                  <p>Illustrator</p>
                </div>
                <div className="work__info__basic__item">
                  {" "}
                  <h5>Tools</h5>
                  <p>Adobe & Affinity Suites, Blender, UCSF Chimera</p>
                </div>
              </div>
            </div>

            <div className="work__info twoColumn">
              <h4>INTRODUCTION</h4>
              <p>
                These are a few print-oriented medical illustrations I've done.
              </p>
            </div>
          </div>
    
        
          <div className="work">
            <div className="work__info narrowColumn">
              <h4>NEUROANATOMY</h4>

              <p>
                This was a didactic illustration of the lateral and mid-sagital
                views of the brain.
              </p>
            </div>
            <div className="work__info wideColumn">
              <img
                src={BrainWIP}
                loading="lazy"
                alt="Brain illustration process."
              ></img>

              <p>Illustration breakdown.</p>
            </div>
          </div>
          <div className="work">
            <div className="work__info singleColumn">
              <img
                src={BrainMockup}
                loading="lazy"
                alt="Final illustrated spread."
              ></img>
            </div>
          </div>
          <div className="work reverse">
            <div className="work__info wideColumn">
              <img
                src={CABG}
                loading="lazy"
                alt="Final illustrated spread."
              ></img>
            </div>

            <div className="work__info narrowColumn ">
              <h4>CORONARY BYPASS SURGERY</h4>

              <p>
                This is a sample from a surgical illustration sequence of double
                coronary bypass grafting (CABG) surgery for Dr. Vivek Rao at
                Toronto General Hospital. This highly research-intensive process
                involved observing half a dozen open heart surgeries, visually
                documenting the procedures and techniques, and validating
                accuracy with the surgeon. All this information was consolidated
                and streamlined into a series of illustrations intended for
                didactic use.
              </p>
            </div>
          </div>{" "}
          <div className="work singleColumn">
            <p>
              These are some of the sketches that were done to document the
              procedure while in the operating theater.
            </p>{" "}
          </div>
          <div className="work">
            <div className="work__info twoColumn">
              <img
                src={CABG_WIP1}
                loading="lazy"
                alt="Final illustrated spread."
              ></img>
            </div>
            <div className="work__info twoColumn">
              <img
                src={CABG_WIP2}
                loading="lazy"
                alt="Final illustrated spread."
              ></img>
            </div>
          </div>      
          <div className="work">
            <div className="work__info twoColumn">
              <h4>FIBRIN</h4>
              <p>
                Fibrin is a protein that is critical for hemostasis and wound
                healing, due to the significant structural properties it
                exhibits when activated. I designed this two-page spread for a
                popular science magazine to explain the molecular mechanism by
                which this occurs to a lay audience.
              </p>
              <p>
                Protein models were derived from the following PDB datasets:{" "}
                <a href="https://www.rcsb.org/structure/1FZE">
                  1FZE (fibrin D-dimers)
                </a>{" "}
                ,{" "}
                <a href="https://www.rcsb.org/structure/3GHG">
                  3GHG (fibrinogen)
                </a>
                , and{" "}
                <a href="https://www.rcsb.org/structure/2a45">
                  2A45 (thrombin)
                </a>
                .
              </p>
            </div>
          </div>
          <div className="work">
            <div className="work__info id=" singleColumn>
              <img
                src={FibrinSpread}
                loading="lazy"
                alt="Final illustrated spread."
              ></img>
            </div>
          </div>
        </div>

        <ContactCTA />
      </div>
    </>
  );
}

export default MedIllus;
